module.exports = __webpack_public_path__ + "media/images/emoticons/sandclock-dac618e080e64b091113bd1af20b585f.gif";